import { observable } from 'mobx'

import { z } from '@authy/lib-common/utils/zod'
import { client, RouterInput } from '@authy/lib-client/trpc'

import { appState } from '@/appState'

type SortType = NonNullable<RouterInput['api']['listApiKeys']['sort']>

export const SearchSchema = z.object({
    sort: z
        .string()
        .transform((val) => val as Extract<keyof SortType, string>)
        .optional()
        .default('description'),
    sortBy: z.enum(['asc', 'desc']).optional().default('asc'),
    searchTerm: z.string().optional(),
})

export type Search = z.infer<typeof SearchSchema>

export const pageSize = 50

export const listApiKeys = async (search: Search, offset: number, abortController?: AbortController) => {
    const result = await client.api.listApiKeys.query(
        {
            tenantId: appState.tenant?._id.toString() ?? '',
            searchTerm: search.searchTerm,
            sort: {
                [search.sort]: search.sortBy,
            },
            offset,
            limit: pageSize,
            returnCount: offset === 0,
        },
        { signal: abortController?.signal }
    )

    return observable(result)
}
